export enum InvoiceType {
  Temporary = 'TEMPORARY',
  Purchase = 'PURCHASE',
  Correction = 'CORRECTION',
}
